import React from 'react';
import '../../styles/_ScrollArrow.css';
import { Col } from "react-bootstrap";
import { NavLink } from 'react-router-dom';

export const ScrollArrowTo2 = () => {
    return (
        <Col lg={1} md={1} id='scroll-right1'>
            <div className='do-scroll-right'>
                <NavLink to='/aboutegypt'><div className='animated-right scroll-transition'></div></NavLink>
            </div> 
        </Col>
    )
}

export const ScrollBackTo1 = () => {
    return (
        <Col lg={1} md={1} id='scroll-left1'>
            <div className='do-scroll-left'>
                <NavLink to='/aboutme'><div className='animated-right  scroll-transition'></div></NavLink>
            </div>
        </Col>
    )
}

export const ScrollArrowTo3 = () => {
    return (
        <Col lg={1} md={1} id='scroll-right2'>
            <div className='do-scroll-right'>
                <NavLink to='/aboutlab'><div className='animated-right  scroll-transition'></div></NavLink>
            </div>
        </Col>
    )
}

export const ScrollBackTo2 = () => {
    return (
        <Col lg={1} md={1} id='scroll-left2'>
            <div className='do-scroll-left'>
                <NavLink to='/aboutegypt'><div className='animated-right scroll-transition'></div></NavLink>
            </div>
        </Col>
    )
}


// WEBPACK FOOTER //
// ./src/components/About/ScrollArrow.js